import { z } from 'zod';

import { dateTimeSchema } from '@apple/utils/globalization/models';

import type { StoreId } from '@apple/features/store/models';
import {
	type StoreEventType,
	storeEventTypeSchema,
} from '@apple/features/store-events/models/shared';

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventHeaderApiController.StoreEventHeaderModel */
export interface StoreEventHeaderModel {
	storeName: string;
	storeThirdPartyId: StoreId;
	openItemCount: number | null;
	earlyManagementKitCutoffDays: number | null;
	fullKitCutoffDays: number | null;
	type: StoreEventType | null;
	eventDate: Date | null;
}

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventHeaderApiController.StoreEventHeaderModel */
export const storeEventHeaderModelSchema = z.object({
	storeName: z.string(),
	storeThirdPartyId: z.string(),
	openItemCount: z.number().nullable(),
	earlyManagementKitCutoffDays: z.number().nullable(),
	fullKitCutoffDays: z.number().nullable(),
	type: storeEventTypeSchema.nullable(),
	eventDate: dateTimeSchema.nullable(),
}) as z.ZodType<StoreEventHeaderModel>;
